import React, { useState, useEffect } from 'react';
import styles from './Modal.module.scss';
// @ts-ignore
import classNames from 'classnames';
import { ConfigModalType } from './types/ConfigModalType';
import { TranslationService } from 'src/core/services';

type PropsType = {
  id?: string;
  isOpen: boolean;
  children: React.ReactNode;
  className?: string;
  closeBtnClass?: string;
  wrapperClassName?: string;
  config?: ConfigModalType;
  onToggle: (isOpen: boolean) => void;
  ariaLabel?: string;
};

const Modal = ({
  config = {
    noAnimation: false,
    noOverlay: false,
  },
  ...props
}: PropsType) => {
  const [isOpen, setIsOpen] = useState<boolean>(props.isOpen);

  const handleClick = () => {
    setIsOpen(false);
    props.onToggle(false);
  };

  useEffect(() => {
    setIsOpen(props.isOpen);
  }, [props.isOpen]);

  return (
    <>
      {isOpen && (
        <div
          data-testid="modal-wrapper"
          className={classNames(
            styles.wrapper,
            props.wrapperClassName,
            config.noAnimation && styles.noAnimation,
            config.noOverlay && styles.noOverlay
          )}
        >
          <div data-testid="modal" className={classNames(styles.modal, props.className)}>
            <button
              id={props.id}
              type="button"
              className={classNames(styles.close, props.closeBtnClass)}
              onClick={handleClick}
              aria-label={TranslationService.translate('Close')}
            ></button>

            {props.children}
          </div>
        </div>
      )}
    </>
  );
};

export default Modal;
